/** @jsx h */
/** @jsxFrag Fragment */
import { h, Fragment, createContext } from "preact";
import { Form } from "./FormTypes";
import { useContext } from "preact/hooks";

const FormContext = createContext<Form | null>(null);

export const FormProvider = ({
  form,
  children,
}: {
  form: Form;
  children: any;
}) => {
  return <FormContext.Provider value={form}>{children}</FormContext.Provider>;
};

export const useFormData = () => {
  return useContext(FormContext);
};
